export default __webpack_public_path__ + "static/media/company_seed.436dc261.png";